<div class="modal fade" id="updateUserModal" msEscClose (escPressed)="onCancelRequested()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">Update Information</h5>
            </div>
            <div class="modal-body text-center">
                <ms-update-user-form
                    [(selectedUser)]="user"
                    (cancelRequested)="onCancelRequested()"
                    (editConfirmationRequested)="onEditConfirmationRequested()"
                    (submissionResult)="onUpdateUserResult($event)">
                </ms-update-user-form>
            </div>
        </div>
    </div>
</div>

<ms-confirmation-modal #updateUserConfirmationModalRef modalId="updateUserConfirmationModal"
    confirmButtonText="Leave" cancelButtonText="Stay"
    (confirmed)="confirmationConfirmFunction()"
    (cancelled)="confirmationCancelFunction()"
/>

<ms-confirmation-modal
    #updateUserSaveConfirmationModalRef
    modalId="updateUserSaveConfirmationModal"
    confirmButtonText="Save"
    cancelButtonText="Cancel"
    (confirmed)="editConfirmationModalConfirmed()"
    (cancelled)="editConfirmationModalCancelled()"
/>

<ms-info-modal #updateUserInfoModalRef modalId="updateUserInfoModal" />